type PaymentsToolbarProps = Record<string, never>;

export function PaymentsToolbar(_props: PaymentsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ລາຍການຊຳລະ</h2>
          <p className="text-muted-foreground">ເບິ່ງລາຍການການຊຳລະ ແລະ ສະຖານະ</p>
        </div>
      </div>
    </div>
  );
}
